import { DisabledPrompt, useRoute, useStateManager } from "@bcm-dev/bcms-vite";
import UIRadioGroup, { UIRadio } from "components/custom-ui/UIRadioGroup";
import { FormContainer, FormRowView, WidgetContainer, WidgetView } from "components/shared";
import { FormButtonRow } from "components/shared/containers/FormContainer";
import { PrimaryButton, SecondaryButton, UIPhoneNumberInput, UITextInput } from "components/ui";
import React from "react";

/**
 * @function PhoneNumberWidget
 * @return {React.Component}
 * @exported true
 * @description The main widget used in the ACTContactInfoForeignPage. 
 */
export default function PhoneNumberWidget(props) {
  const navigate = useRoute();
  const { data, onFormChange } = useStateManager();
  const addressType = data.addressType.phoneNumberType;

  return (
    <WidgetContainer className="phone-number-widget">
      <WidgetView text="Phone Number">
        <p className="form-description-text">
          Below are your current contact numbers in our system. To update to a foreign number, please add the country code.
          If you have a foreign and domestic contact number, please add (1) before the domestic number and keep the Address Type as "Foreign".
        </p>
        <FormContainer className="phone-number-radio-form">
          <FormRowView className="phone-number-type-row-view" text="*Address Type">
            <UIRadioGroup direction="horizontal" value={addressType} onChange={onFormChange("phoneNumberType")}>
              <UIRadio className="domestic-ui-radio" label="Domestic" name="address-type" value="domestic" />
              <UIRadio className="foreign-ui-radio" label="Foreign" name="address-type" value="foreign" />
            </UIRadioGroup>
          </FormRowView>
        </FormContainer>
        <FormContainer className="phone-number-form small-form-width">
          {addressType === "domestic" &&
            <>
              <FormRowView className="home-phone-row-view" text="Home Phone">
                <UIPhoneNumberInput />
              </FormRowView>
              <FormRowView className="work-phone-row-view" text="Work Phone">
                <UIPhoneNumberInput />
              </FormRowView>
              <FormRowView className="mobile-phone-row-view" text="Mobile Phone">
                <UIPhoneNumberInput />
              </FormRowView>
            </>}
          {addressType === "foreign" &&
            <>
              <FormRowView className="foreign-home-phone-row-view" text="Home Phone">
                <span className="phone-plus-symbol">+</span>
                <UITextInput />
              </FormRowView>
              <FormRowView className="foreign-work-phone-row-view" text="Work Phone">
                <span className="phone-plus-symbol">+</span>
                <UITextInput />
              </FormRowView>
              <FormRowView className="foreign-mobile-phone-row-view" text="Mobile Phone">
                <span className="phone-plus-symbol">+</span>
                <UITextInput />
              </FormRowView>
            </>}


          <FormButtonRow>
            <SecondaryButton text="Cancel" onClick={() => { navigate("/profile") }} />
            <DisabledPrompt>
              <PrimaryButton text="Update" />
            </DisabledPrompt>
          </FormButtonRow>
        </FormContainer>
      </WidgetView>
    </WidgetContainer>
  )
}
